export const toggleValueInArray = <T>(value: T | undefined, arr?: T[] | null) => {
  if (!value) {
    return [];
  }

  if (!arr) {
    return [value];
  }

  return arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
};

export const addOptionalFilter = <T>(value: T[]) => (value.length ? value : undefined);
